import { call, put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  resetGoBizPasswordFailure,
  resetGoBizPasswordSuccess,
} from './actions';
import { RESET_PASSWORD } from './types';
import { resetGoBizPassword } from './api';
import { error as errorNotification } from '../notifications/actions';

export function* resetPasswordSaga(action) {
  try {
    const { email } = action.payload;
    yield call(resetGoBizPassword, email);

    yield put(resetGoBizPasswordSuccess());
    yield put(push('/reset-gobiz-password-done'));
  } catch (error) {
    yield put(resetGoBizPasswordFailure(error));
    yield put(errorNotification(error.message));
  }
}

export default function* authSaga() {
  yield takeEvery(RESET_PASSWORD, resetPasswordSaga);
}
